import React from 'react'
import styled from 'styled-components'

import { Box, Text } from '@usap/uicomponents'

export const PartNoBox = styled(Box)`
  margin-bottom: 8px;
`

export const ItemTotalBox = styled(Box)`
  padding-top: 4px;
  padding-bottom: 4px;
  flex-direction: row;
  align-items: center;
`

export const ItemTotalValue = styled(Text)`
  margin-left: 2px;
`

export const ShippingMethodValue = styled(Text)`
  margin-left: 2px;
`
